import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Slider from '@material-ui/core/Slider'
import Typography from '@material-ui/core/Typography'
import Box from '@material-ui/core/Box'

import InfoButton from '../../InfoButton'

import { setReallocatePercentageAction } from '../../../redux/reducers/criteria/actions'

const marks = [
  { value: 0, label: '0%' },
  { value: 25, label: '25%' },
  { value: 50, label: '50%' },
  { value: 75, label: '75%' },
  { value: 100, label: '100%' },
]

const ReallocatePercentage = () => {
  const dispatch = useDispatch()
  const reallocatePercentage = useSelector(
    state => state.criteria.reallocatePercentage
  )
  const [localValue, setLocalValue] = useState(reallocatePercentage)

  return (
    <>
      <Box display="flex">
        <Typography id="reallocate-percentage">
          Percentage of stock to reallocate
          <InfoButton
            tooltipContent={
              <>
                <Typography variant="h6" gutterBottom>
                  Percentage of stock to reallocate
                </Typography>
                <Typography variant="body2" gutterBottom>
                  The percentage of stock that is recalled that is then sent
                  (reallocated) to different branches (including Home Shopping).
                  The remaining stock is kept in warehouse.
                </Typography>
              </>
            }
          />
        </Typography>
      </Box>
      <Slider
        aria-labelledby="reallocate-percentage"
        value={localValue}
        getAriaValueText={v => v.toString()}
        marks={marks}
        max={100}
        min={0}
        onChange={(_, value) => setLocalValue(value)}
        onChangeCommitted={() => dispatch(setReallocatePercentageAction(localValue))}
        step={1}
        valueLabelDisplay="auto"
        valueLabelFormat={x => `${x.toString()}%`}
      />
    </>
  )
}

export default ReallocatePercentage
